import { messageTypes, TipperHighlightType } from "@const/livestreams";
import NewTextMessage from "./NewTextMessage";
import NewTipMessage from "./NewTipMessage";
import NewViewerMessage from "./NewViewerMessage";

const Message = (props) => {
  const { type, topTippers = [] } = props;
  const topTippersIds = topTippers.map((tipper) => tipper?.id);
  const topTippedIndex = topTippersIds.indexOf(props.streamParticipant?.id);

  if (type === messageTypes.text) {
    return (
      <NewTextMessage
        {...props}
        type={TipperHighlightType[topTippedIndex]}
        textClassName="text-primary"
        chatUsernameClassName="text-primary"
      />
    );
  }

  if (type === messageTypes.tip) {
    return (
      <NewTipMessage {...props} type={TipperHighlightType[topTippedIndex]} />
    );
  }

  if (type === messageTypes.userJoined) {
    return <NewViewerMessage {...props} />;
  }
};
export default Message;
